const UNMASK_SELECTOR = [
  "button",
  "a",
  "label",
  "th",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "legend",
  "summary",
  "[role='tab']",
  "[role='menuitem']",
  "[role='button']",
  "[role='columnheader']",
  "[data-ph-unmask]",
].join(",");

const MASKED = "*";

export function maskReplayText(text: string, element?: HTMLElement): string {
  if (element?.closest("[data-ph-mask]")) return text.replace(/\S/g, MASKED);

  if (element?.closest(UNMASK_SELECTOR)) return text;

  return text.replace(/\S/g, MASKED);
}
